const routes = [{
  path: '/wxwait/:itemId/:orderId/',
  load: () => import(/* webpackChunkName: 'wait' */ './wxwait'),
}]

export default routes



// WEBPACK FOOTER //
// ./src/routes/pay/index.js